module.exports = __webpack_public_path__ + "img/da-4.5ea25b82.png";